module.exports = __webpack_public_path__ + "images/img-3ZhBTsQ.jpg";


//////////////////
// WEBPACK FOOTER
// ./frontend/cabinets/apps/rocket/assets/img/dashboard/year-results/en/offer.jpg
// module id = 2001
// module chunks = 0